export default __webpack_public_path__ + "static/media/redflag.969493da.png";